const ActionMenuData = [
  {
    name: "Lists",
    key: "list",
  },
  {
    name: "Compare",
    key: "compare",
  },
  {
    name: "Send Email",
    key: "sendEmail",
  },
  {
    name: "Download Resume",
    key: "downloadResume",
  },
];

// custom menu data

const customView = {
  mostCommanUsed: [
    {
      headerName: "Percentile Rank",
      field: "percentileRank",
      sort: "desc",
      width: 120,
      headerAlign: "center",
      align: "center",
      fieldType: "number",
    },
    {
      headerName: "Total Score",
      field: "totalScore",
      sort: "desc",
      width: 120,
      headerAlign: "center",
      align: "center",
      fieldType: "number",
    },
    {
      headerName: "University",
      field: "university",
      sort: "desc",
      width: 200,
      headerAlign: "left",
      align: "left",
      fieldType: "text",
    },

    {
      headerName: "Specialization",
      field: "specialization",
      sort: "desc",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Qualification",
      field: "qualification",
      sort: "desc",
      width: 200,
      headerAlign: "left",
      align: "left",
      fieldType: "date",
    },
    {
      headerName: "Primary Area Of Interest",
      field: "areaOfInterest1",
      sort: "desc",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
  ],
  personalMenu: [
    {
      headerName: "Name",
      field: "name",
      sort: "desc",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Email",
      field: "email",
      sort: "desc",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Gender",
      field: "gender",
      sort: "desc",
      width: 120,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Date Of Birth",
      field: "dob",
      sort: "desc",
      width: 120,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Phone",
      field: "phone",
      sort: "desc",
      width: 120,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "City",
      field: "city",
      sort: "desc",
      width: 120,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Country",
      field: "country",
      sort: "desc",
      width: 120,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Address",
      field: "address",
      sort: "desc",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Nationality",
      field: "nationality",
      sort: "desc",
      width: 120,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Country of Residence",
      field: "currentCountry",
      width: 120,
      headerAlign: "left",
      align: "left",
    },

    {
      headerName: "Identity Card",
      field: "cnic",
      width: 200,
      headerAlign: "left",
      align: "left",
    },

    {
      headerName: "Identity Card Issuance Date",
      field: "cnicIssuanceDate",
      width: 120,
      headerAlign: "center",
      align: "center",
    },

    {
      headerName: "Health Disability",
      field: "healthDisability",
      width: 120,
      headerAlign: "center",
      align: "center",
    },
  ],
  educationMenu: [
    {
      headerName: "Country of Highest Education",
      field: "countryOther",
      sort: "desc",
      width: 120,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "University",
      field: "university",
      sort: "desc",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Qualification",
      field: "qualification",
      sort: "desc",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Specialization",
      field: "specialization",
      sort: "desc",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Graduation Date",
      field: "graduationDate",
      sort: "desc",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Degree Duration",
      field: "degreeDuration",
      sort: "desc",
      width: 120,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Grading System",
      field: "gradingSystem",
      sort: "desc",
      width: 120,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Grade",
      field: "gradingValue",
      sort: "desc",
      width: 120,
      headerAlign: "left",
      align: "left",
    },
  ],
  interestMenu: [
    {
      headerName: "Primary Area Of Interest",
      field: "areaOfInterest1",
      sort: "desc",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Secondary Area Of Interest",
      field: "areaOfInterest2",
      sort: "desc",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Preferred City to Work in",
      field: "preferredCity",
      sort: "desc",
      width: 120,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Resume",
      field: "resume",
      sort: "desc",
      width: 200,
      headerAlign: "left",
      align: "left",
    },
  ],
  totalScoresMenu: [
    {
      headerName: "Total Score",
      field: "totalScore",
      sort: "desc",
      width: 120,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Total Competency Score",
      field: "totalCompetencyScore",
      sort: "desc",
      width: 120,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Total Cognitive Score",
      field: "totalConativeScore",
      sort: "desc",
      width: 120,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Percentile Rank",
      field: "percentileRank",
      sort: "desc",
      width: 120,
      headerAlign: "center",
      align: "center",
    },
  ],
  gameMenu: [
    {
      headerName: "Date Game Started",
      field: "createdAt",
      sort: "desc",
      width: 120,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Last Date Updated",
      field: "updatedAt",
      sort: "desc",
      width: 120,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Game Play Percentage",
      field: "gamePlayPercentage",
      sort: "desc",
      width: 120,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Lock Status",
      field: "userLockStatus",
      sort: "desc",
      width: 120,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "Lock Type",
      field: "userLockType",
      sort: "desc",
      width: 120,
      headerAlign: "left",
      align: "left",
    },
  ],
};

let NumberFilterTypes = [
  {
    name: "Equal",
    key: "_e",
  },
  {
    name: "Greater Than",
    key: "_gt",
  },

  {
    name: "Less Than",
    key: "_lt",
  },

  {
    name: "Not Equal",
    key: "_ne",
  },
];

let TextFilterTypes = [
  {
    name: "Like",
    key: "_like",
  },
  {
    name: "Equal",
    key: "_e",
  },
  {
    name: "Not Equal",
    key: "_ne",
  },
];

let DateFilterTypes = [
  {
    name: "Is",
    key: "_e",
  },
  {
    name: "Before",
    key: "_lt",
  },
  {
    name: "After",
    key: "_gt",
  },
];

let DropdownFilterTypes = [
  {
    name: "Like",
    key: "_like",
  },
  {
    name: "Equal",
    key: "_e",
  },
  {
    name: "Not Equal",
    key: "_ne",
  },
];

let HealthDisabilityTypes = [
  {
    name: "Equal",
    key: "_e",
  },
  {
    name: "Not Equal",
    key: "_ne",
  },
];

let LockStatusLockType = [
  {
    name: "Equal",
    key: "_e",
  },
];

let operatorData = [
  {
    name: "Or",
    key: "or",
  },
  {
    name: "And",
    key: "and",
  },
];

export {
  ActionMenuData,
  customView,
  NumberFilterTypes,
  TextFilterTypes,
  operatorData,
  DateFilterTypes,
  DropdownFilterTypes,
  HealthDisabilityTypes,
  LockStatusLockType,
};
